import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    FETCH_ALL_HEALTH_PARTNER,
    UPDATE_HEALTH_PARTNER,
    CREATE_HEALTH_PARTNER, DELETE_HEALTH_PARTNER
} from 'constants/health_partners.constants'
import axios from 'axios'
import {
    fetchHealthPartnersSuccess,
    updateHealthPartnerSuccess,
    createHealthPartnerSuccess,
    deleteHealthPartnerSuccess
} from "actions/health_partners.action";
import { showErrors, stopLoader } from "actions/general.action";


// health_partner sagas

const fetchHealthPartnersRequest = async (page) => {
    return axios.get('/api/v1/super_admin/health_partners');
}

function* fetchHealthPartners({ payload }) {
    try {
        const reuslt = yield call(fetchHealthPartnersRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchHealthPartnersSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const updateHealthPartnersRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.partner_type = {id: payload.health_partner_type_id}
    o.country = {id: payload.country_id}

    return axios.put('/super_admin/health_partners/' + payload.id,
        o
    );
}

function* updateHealthPartner({ payload }) {
    try {
        const reuslt = yield call(updateHealthPartnersRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updateHealthPartnerSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const createHealthPartnersRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.partner_type = {id: payload.health_partner_type_id}
    o.country = {id: payload.country_id}

    return axios.post('/api/v1/super_admin/health_partners',
        o
    );
}

function* createHealthPartner({ payload }) {
    try {
        const reuslt = yield call(createHealthPartnersRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield all([
                put(createHealthPartnerSuccess(reuslt.data)),
                //put(stopLoader("HealthPartner created"))
            ])
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const deleteHealthPartnersRequest = async (id) => {
    return axios({
        method: "delete",
        url: '/api/v1/super_admin/health_partners/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deleteHealthPartner({ payload }) {
    try {
        const reuslt = yield call(deleteHealthPartnersRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deleteHealthPartnerSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}


// fork health_partner
export function* forkFetchHealthPartners() {
    yield takeEvery(FETCH_ALL_HEALTH_PARTNER, fetchHealthPartners);
}

export function* forkUpdateHealthPartner() {
    yield takeEvery(UPDATE_HEALTH_PARTNER, updateHealthPartner);
}

export function* forkCreateHealthPartner() {
    yield takeEvery(CREATE_HEALTH_PARTNER, createHealthPartner);
}

export function* forkDeleteHealthPartner() {
    yield takeEvery(DELETE_HEALTH_PARTNER, deleteHealthPartner);
}


export default function* rootSaga() {
    yield all([
        fork(forkFetchHealthPartners),
        fork(forkUpdateHealthPartner),
        fork(forkCreateHealthPartner),
        fork(forkDeleteHealthPartner),
    ]);
}